/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from './ui-elements/watermark/watermark.component.ngfactory';
import * as import2 from './ui-elements/watermark/watermark.component';
import * as import3 from 'ng2-translate/src/translate.pipe';
import * as import4 from 'ng2-translate/src/translate.service';
import * as import5 from './ui-elements/icon-library/icon-library.component.ngfactory';
import * as import6 from './ui-elements/icon-library/icon-library.component';
import * as import7 from './orchestration/page-container/page-container.component.ngfactory';
import * as import8 from './orchestration/page-container/page-container.component';
import * as import9 from './orchestration/navigation.service';
import * as import10 from '@angular/common';
import * as import11 from './ui-elements/loading/loading-spinner/loading-spinner.component.ngfactory';
import * as import12 from './ui-elements/loading/loading-spinner/loading-spinner.component';
import * as import13 from './ui-elements/loading/loading.service';
import * as import14 from './app.component';
import * as import15 from './theme/theme.model';
import * as import16 from './orchestration/responsive.service';
import * as import17 from '@fedelta-pos/data-client/versioning/version.service';
import * as import18 from '@fedelta-pos/data-client/auth/auth.service';
import * as import19 from './notification/notification.service';
import * as import20 from '@ionic-native/status-bar/index';
import * as import21 from 'ionic-angular/platform/platform';
import * as import22 from '@fedelta-pos/data-client/configuration/local-configuration.service';
import * as import23 from './orchestration/session.model';
const styles_MyApp:any[] = ([] as any[]);
export const RenderType_MyApp:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_MyApp,
  data: {}
}
);
function View_MyApp_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-watermark',([] as any[]),(null as any),(null as any),(null as any),import1.View_WatermarkComponent_0,import1.RenderType_WatermarkComponent)),
      import0.ɵdid(49152,(null as any),0,import2.WatermarkComponent,([] as any[]),{text: [
        0,
        'text'
      ]
    },(null as any)),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('woa.message.timeTestModeWatermark'));
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_MyApp_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-watermark',([] as any[]),(null as any),(null as any),(null as any),import1.View_WatermarkComponent_0,import1.RenderType_WatermarkComponent)),
      import0.ɵdid(49152,(null as any),0,import2.WatermarkComponent,([] as any[]),{text: [
        0,
        'text'
      ]
    },(null as any)),
    import0.ɵpid(131072,import3.TranslatePipe,[
      import4.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('woa.message.testModeWatermark'));
    ck(v,1,0,currVal_0);
  },(null as any));
}
export function View_MyApp_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-library',([] as any[]),(null as any),(null as any),(null as any),import5.View_IconLibraryComponent_0,import5.RenderType_IconLibraryComponent)),
    import0.ɵdid(49152,(null as any),0,import6.IconLibraryComponent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-page-container',([] as any[]),[[
        2,
        'hidden',
        (null as any)
      ]
    ],(null as any),(null as any),import7.View_PageContainerComponent_0,import7.RenderType_PageContainerComponent)),
    import0.ɵdid(245760,(null as any),0,import8.PageContainerComponent,[
      import0.ElementRef,
      import9.NavigationService,
      import0.Injector,
      import0.ChangeDetectorRef
    ]
      ,{rootSelector: [
        0,
        'rootSelector'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MyApp_1)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MyApp_2)),
    import0.ɵdid(16384,(null as any),0,import10.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-loading-spinner',([] as any[]),(null as any),(null as any),(null as any),import11.View_LoadingSpinnerComponent_0,import11.RenderType_LoadingSpinnerComponent)),
    import0.ɵdid(245760,(null as any),0,import12.LoadingSpinnerComponent,[
      import0.ChangeDetectorRef,
      import13.LoadingService
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import14.MyApp = v.component;
    const currVal_1:any = 'woa-entry-page';
    ck(v,4,0,currVal_1);
    const currVal_2:any = co.sessionModel.timeTestMode;
    ck(v,7,0,currVal_2);
    const currVal_3:boolean = ((!co.sessionModel.timeTestMode && ((co.sessionModel == null)? (null as any): co.sessionModel.currentApp)) && !((co.sessionModel == null)? (null as any): ((co.sessionModel.currentApp == null)? (null as any): co.sessionModel.currentApp.appLiveMode)));
    ck(v,10,0,currVal_3);
    ck(v,13,0);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,4).hidden;
    ck(v,3,0,currVal_0);
  });
}
function View_MyApp_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ion-app',([] as any[]),(null as any),[[
        'window',
        'message'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('window:message' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).previewRefresh($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_MyApp_0,RenderType_MyApp)),
    import0.ɵdid(49152,(null as any),0,import14.MyApp,[
      import15.ThemeModel,
      import9.NavigationService,
      import16.ResponsiveService,
      import17.VersionService,
      import4.TranslateService,
      import18.AuthService,
      import19.NotificationService,
      import20.StatusBar,
      import21.Platform,
      import22.LocalConfigurationService,
      import23.SessionModel
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const MyAppNgFactory:import0.ComponentFactory<import14.MyApp> = import0.ɵccf('ion-app',import14.MyApp,View_MyApp_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL3J1bm5lci93b3JrL3dlYi1vcmRlcmluZy1hcHAvd2ViLW9yZGVyaW5nLWFwcC9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cy5NeUFwcF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjx3b2EtaWNvbi1saWJyYXJ5Pjwvd29hLWljb24tbGlicmFyeT5cbjx3b2EtcGFnZS1jb250YWluZXIgW3Jvb3RTZWxlY3Rvcl09XCInd29hLWVudHJ5LXBhZ2UnXCI+PC93b2EtcGFnZS1jb250YWluZXI+XG48d29hLXdhdGVybWFyayAqbmdJZj1cInNlc3Npb25Nb2RlbC50aW1lVGVzdE1vZGVcIlxuICAgICAgICAgICAgICAgW3RleHRdPVwiJ3dvYS5tZXNzYWdlLnRpbWVUZXN0TW9kZVdhdGVybWFyaycgfCB0cmFuc2xhdGVcIj48L3dvYS13YXRlcm1hcms+XG48d29hLXdhdGVybWFyayAqbmdJZj1cIiFzZXNzaW9uTW9kZWwudGltZVRlc3RNb2RlICYmIHNlc3Npb25Nb2RlbD8uY3VycmVudEFwcCAmJiAhc2Vzc2lvbk1vZGVsPy5jdXJyZW50QXBwPy5hcHBMaXZlTW9kZVwiXG4gICAgICAgICAgICAgICBbdGV4dF09XCInd29hLm1lc3NhZ2UudGVzdE1vZGVXYXRlcm1hcmsnIHwgdHJhbnNsYXRlXCI+PC93b2Etd2F0ZXJtYXJrPlxuPHdvYS1sb2FkaW5nLXNwaW5uZXI+PC93b2EtbG9hZGluZy1zcGlubmVyPlxuIiwiPGlvbi1hcHA+PC9pb24tYXBwPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lDRUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFDZTs7O0lBQUE7SUFBQTs7O0lBQUE7SUFEZixTQUNlLFNBRGY7Ozs7O0lBRUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFDZTs7O0lBQUE7SUFBQTs7O0lBQUE7SUFEZixTQUNlLFNBRGY7Ozs7O0lBSkE7Z0JBQUE7SUFBcUM7TUFDckM7UUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBOzs7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUEyRTtJQUMzRTtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQ3dGO0lBQ3hGO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFDb0Y7SUFDcEY7Z0JBQUE7OztJQUFBO0tBQUE7SUFBMkM7Ozs7SUFMdkI7SUFBcEIsU0FBb0IsU0FBcEI7SUFDZTtJQUFmLFNBQWUsU0FBZjtJQUVlO0lBQWYsVUFBZSxTQUFmO0lBRUE7O0lBTEE7SUFBQSxTQUFBLFNBQUE7Ozs7O01DREE7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtJQUFBO2dCQUFBOzs7Ozs7Ozs7Ozs7SUFBQTtLQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/app/app.component.ngfactory.ts